import "./styles/mediumTableDetailCard/mediumTableDetailCard.css";

import React, { useEffect, useState } from "react";

import { withNamespaces } from "react-i18next";

import MediumTable from "../../components/Table/MediumTable/MediumTable";
import WhiteButton from "../../components/form_components/Buttons/WhiteButton/WhiteButton";
import { AuthContextValue } from "../../context/AuthContext";
import { GetContextValue } from "../../context/GetContext";
import useFetch from "../../hooks/UseFetch";
import Loading from "../../components/Loading/Loading";
import { Link } from "react-router-dom";
import ErrorComponent from "../../components/ErrorComponent/ErrorComponent";

function AllTenderCard({t}) {
  const { token } = AuthContextValue();
  const { notificationRender } = GetContextValue();

  /* Tablodan seçilen değerleri tutan stateler */
  const [selectValue, setSelectValue] = useState(null);
  const [selectValueId, setSelectValueId] = useState(null);

  const status = 2;

  const {
    setUseFetchRender: setAllTendersUseFetchRender,
    useFetchRender: allTendersUseFetchRender,
    error: allTendersError,
    loading: allTendersLoading,
    data: allTenders,
    total: allTendersTotal,
  } = useFetch(
    `${
      process.env.REACT_APP_GET_TENDER_LIST_URL
    }?Status=${status}&Last=true&SortType=${3}&Page=${1}&PageSize=${5}`,
    token
  );


  const columns = [
    {
      key: "tenderCompanyName",
      header: t("table_company_name"),
    },
    {
      key: "createdUser",
      header: t("support_request_created_user"),
    },
    {
      key: "productName",
      header: t("table_product"),
    },
    {
      key: "minPrice",
      header: t("table_min_price"),
    },
    {
      key: "maxPrice",
      header: t("table_max_price"),
    },
    {
      key: "passedDay",
      header: t("table_passed_time"),
    },
  ];

  useEffect(() => {
    setAllTendersUseFetchRender(!allTendersUseFetchRender);
  }, [notificationRender]);

  /* sayfaya girdiğimizde contextte var olan veriyi siler */
  useEffect(() => {
    setSelectValue(null);
    setSelectValueId(null);
  }, []);

  function handleClickValue(valueId, value) {
    setSelectValueId(valueId);
    setSelectValue(value);
  }

  return (
    <div className="medium-table-container">
      <div className="table-top">
        <div className="title-box">
          <i className="fa-solid fa-star"></i>
          <h5>{t("tenders_title")}</h5>
        </div>
        <div className="buttons">
          <WhiteButton
            icon={<i className="fa-solid fa-arrow-rotate-left"></i>}
            tooltip={t("button_edit_render")}
            onClick={() => {
              setAllTendersUseFetchRender(!allTendersUseFetchRender);
              setSelectValue(null);
              setSelectValueId(null);
            }}
          />
          <Link
            to={
              selectValue || selectValueId
                ? `/tenders/tender-detail/${selectValueId}`
                : false
            }
          >
            <WhiteButton
              disabled={selectValue || selectValueId ? false : true}
              icon={<i className="fa-solid fa-info"></i>}
              tooltip={t("button_edit_detail")}
            />
          </Link>
        </div>
      </div>

      <div className="table-main">
        {allTendersError ? (
          <ErrorComponent error={allTendersError} />
        ) : allTendersLoading ? (
          <Loading />
        ) : allTenders !== null && allTenders.length > 0 ? (
          <MediumTable
            type="tender"
            selectValueId={selectValueId}
            selectValue={selectValue}
            handleClickValue={handleClickValue}
            columns={columns}
            data={allTenders}
          />
        ) : (
          <p className="table-null-text">{t("message_opened_auction_no")}</p>
        )}
      </div>
    </div>
  );
}

export default withNamespaces()(AllTenderCard);
